import React, { PropsWithChildren } from 'react';

import * as S from './styles';
import { AsideMenu } from 'components/Main';

interface IMainProps extends PropsWithChildren<any> {}

const SHOW_TEST_ENV_WARNING =
  window.location.hostname === 'hml-bayer.webcol.systems';

export const MainContainer: React.FC<IMainProps> = ({ children }) => {
  return (
    <S.Container>
      <AsideMenu />
      <S.Content className="scrollHidden">
        {SHOW_TEST_ENV_WARNING && (
          <S.TestEnvWarning>Ambiente de homologação</S.TestEnvWarning>
        )}
        {children}
      </S.Content>
    </S.Container>
  );
};
